import { useQuery } from '@tanstack/react-query';
import { fetchMasterExamCategories } from '../services/examCategoryService';

export function useMasterExamCategories(params = {}) {
  const stateId = Number(params?.stateId || 0);
  const favouriteStateId = Number(params?.favouriteStateId || 0);
  const favouriteExamId = Number(params?.favouriteExamId || 0);

  return useQuery({
    queryKey: ['masterExamCategories', stateId, favouriteStateId, favouriteExamId],
    queryFn: () => fetchMasterExamCategories({ stateId, favouriteStateId, favouriteExamId }),
    staleTime: 5 * 60 * 1000,
    retry: 2,
  });
}
